import styled, { css } from 'styled-components';

import { Color } from 'modules/styles/colors';

import { MuiButton } from 'theme/material-ui';

export const LanguageButton = styled(MuiButton)<{ active?: boolean }>`
  && {
    border-radius: 0px;
    background-color: ${Color.white};

    ${({ active }) =>
      active &&
      css`
        && {
          border: 1px solid ${Color.primary};
        }
      `}
  }
`;

export const DownloadButton = styled(MuiButton)`
  && {
    margin: 0 8px;
  }
`;
